/** Muss zu den Startregeln der Paketposition im Backend passen. */
export const START_RULE = { contractStart: 1, trainingStart: 2, signingDate: 3 } as const;

/** Muss zu den Vertragsstart-Voreinstellungen im Backend passen; `legacyFirstOfNextMonth` wird beim Laden auf `firstOfNextMonth` abgebildet. */
export const START_PRESET = { today: 1, tomorrow: 2, firstOfNextMonth: 3, legacyFirstOfNextMonth: 4 } as const;

/** Zahlenwerte von FollowUpMode im Backend. */
export const FOLLOW_UP_MODE = { contractEnd: 1, anyDate: 2 } as const;
export type FollowUpModeValue = typeof FOLLOW_UP_MODE[keyof typeof FOLLOW_UP_MODE];

/** Vorgabe der Folgeaktion für neue und unvollständige Vorlagen. */
export const DEFAULT_FOLLOW_UP_MODE = FOLLOW_UP_MODE.anyDate;

/** Vorgabe der maximalen Ratenzahl, wenn weder Zeile noch Zahlungsplan eine liefern. */
export const DEFAULT_MAX_INSTALLMENT_COUNT = 12;

/** Nachkommastellen bei der Anzeige eines Prozentabschlags. */
export const PERCENT_DISPLAY_FRACTION_DIGITS = 2;

/** Sortierrang der Tarifzeilen: Haupttarif zuerst, anteilige Gebührenbasis zuletzt. */
export const TARIFF_SORT_RANK = { primary: 0, other: 1, proportionalFeeBase: 2 } as const;

/** Höchstzahl der Zeilenaktionen, die in der Positionsliste als Symbole erscheinen. */
export const POSITION_LIST_VISIBLE_ACTION_COUNT = 3;

/** Formularfelder (Wurzelname), die im Reiter Ruhezeiten liegen. */
export const REST_PERIOD_ROOT_FIELDS: readonly string[] = ["allowRestPeriods", "defaultRestPeriodTemplateId"];

/** Formularfeld (Wurzelname), das im Reiter Kündigung liegt. */
export const CANCELLATION_ROOT_FIELD = "defaultCancellationModelId";
